import gql from 'graphql-tag'
import { ItemPastaFragment } from './item-pasta-fragment'

export const BUSCA_QUERY = gql`
  query BuscaBibliotecaPage($filterInput: ItemBibliotecaFilterInput!) {
    buscaBibliotecaPaged(filterInput: $filterInput) {
      content {
        ...ItemPastaFragment
      }
      totalElements
    }
  }
  ${ItemPastaFragment}
`
